import type { OnboardingGroup } from "client/lib/apt-merchant";
import { apiClient } from "client/utils";

export type Credentials = {
  merchantId?: string;
  secretKey?: string;
};
export type CredentialResponse = {
  credentials?: Credentials;
  onboardingGroup?: OnboardingGroup;
};
export const getApcCredentials: () => Promise<CredentialResponse> = async () => {
  const { data } = await apiClient<any>("/api/zdo/get-apc-credentials");

  return data;
};

export type CreateApcResponse = {
  status: "CREATED" | "INELIGIBLE" | "PENDING";
};

export const createApcAccount: () => Promise<CreateApcResponse> = () =>
  apiClient<CreateApcResponse>("/api/zdo/create-account", {
    method: "POST",
  });
